<template>
  <div
    :class="['top-three', colorClass]"
    :style="`background: url(${avatarUrl}); background-size: cover; background-position: center;`"
  >
    <div class="mask">
      <div class="name">{{team.teamName}}</div>
      <div class="score">
        <span class="title">Total</span>
        <span class="value">
          {{(team.total > 0 && team.total !== 999) && $store.state.game.showPlusSigns ? '+' : ''}}{{cleanScore(team.total)}}
        </span>
      </div>
      <div class="score">
        <span class="title">Thru</span>
        <span class="value">{{team.thru}}</span>
      </div>
    </div>
    <span class="place">{{placeText}}</span>
  </div>
</template>
<script>
export default {
  name: 'TopThree',
  props: {
    team: Object,
    place: Number,
  },
  computed: {
    colorClass() {
      switch (this.place) {
        case 0:
          return 'first';
        case 1:
          return 'second';
        default:
          return 'third';
      }
    },
    placeText() {
      switch (this.place) {
        case 0:
          return '1st';
        case 1:
          return '2nd';
        default:
          return '3rd';
      }
    },
    avatarUrl() {
      if (this.team && this.team.avatar && this.team.avatar.avatar) {
        return this.team.avatar.avatar.url;
      }
      return '';
    },    
  },
  methods: {
    roundScore(score) {
      if (score >= 0) {
        return Math.floor(score);
      }
      return Math.ceil(score);
    },
    cleanScore(score) {
      let value = '';
      if (score === null || score === 999) {
        value = '';
      } else if (score === 0) {
        value = 'E';
      } else if (this.$store.state.game.roundScores) {
        value = this.roundScore(score);
      } else {
        value = score;
      }
      console.log(score, value);
      return value;
    },
  },
};
</script>
<style lang="scss" scoped>

  @mixin mobile {
    @media (max-width: 800px) { @content; }
  }

  $gold: #D4AF37;
  $silver: #AAA9AD;
  $bronze: #CD7F32;

  .top-three{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    border: 3px solid $gold;

    &.first {
      border-color: $gold;
      .place {
        background: $gold;
      }
    }
    &.second {
      border-color: $silver;
      .place {
        background: $silver;
      }
    }
    &.third {
      border-color: $bronze;
      .place {
        background: $bronze;
      }
    }

    .image{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      .bg-image{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }

    .mask{
      background: linear-gradient(0deg, rgba(0,0,0,.6) 0%, rgba(0,0,0,.6) 15%, rgba(0,0,0,0) 100%);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      padding: 1rem;
      align-items: flex-end;
      box-sizing: border-box;
      color: white;

      .name{
        font-size: 28px;
        font-weight: bold;
        flex: 1;
        font-style: italic;

        @include mobile{
          font-size: 1.2rem;
        }
      }
      .score{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 2rem;
        text-align: center;
        @include mobile{
          margin-left: 1rem;
        }

        .title{
          font-size: 1.25rem;
          text-transform: uppercase;
          opacity: .8;

          @include mobile{
            font-size: .9rem;
          }
        }
        .value{
          font-size: 1.75rem;
          @include mobile{
            font-size: 1.1rem;
          }
        }
      }
    }

    .place{
      width: 4.5rem;
      height: 4.5rem;
      background: $gold;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      border-radius: 100%;
      border: 2px solid white;
      position: absolute;
      top: 1rem;
      left: 1rem;
      font-size: 1.75rem;
      font-weight: bold;

      @include mobile{
        width: 3rem;
        height: 3rem;
        font-size: 1.2rem;
      }
    }
  }
</style>
